/* Orchard PDP redesign: gallery thumbs, pack slide sync, big price sync. Buy logic stays in orchard-product.js. */
(function () {
  'use strict';
  document.querySelectorAll('[data-oe-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-oe-slide]'), thumbs = hero.querySelectorAll('[data-oe-thumb]');
    function show(name) {
      slides.forEach(function (s) { s.hidden = s.dataset.oeSlide !== name; });
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.oeThumb === name)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.oeThumb); }); });
    var box = hero.querySelector('[data-o-buybox]'), price = hero.querySelector('[data-oe-price]');
    if (!box) return;
    var id = box.querySelector('input[name="id"]'), packId = hero.dataset.packId;
    function sync() {
      var on = box.querySelector('[data-o-plan][aria-checked="true"]:not([hidden]) [data-o-plan-price]');
      var chip = box.querySelector('[data-o-variant][aria-checked="true"] span');
      var txt = on ? on.textContent : (chip ? chip.textContent.split('·')[0] : null);
      if (price && txt) price.textContent = txt.trim();
    }
    /* singles never subscribe: hide how-often, force one-time so no selling_plan is sent */
    var plans = box.querySelector('[data-oe-plans]'), form = box.querySelector('form[data-o-buy]');
    function guardSingle() {
      var chip = box.querySelector('[data-o-variant][aria-checked="true"]');
      var single = !!(chip && chip.hasAttribute('data-oe-single'));
      var once = box.querySelector('[data-o-plan="once"]');
      if (!plans || !once) return;
      if (single) {
        if (once.getAttribute('aria-checked') !== 'true') once.click();
        plans.hidden = true;
        var sp = box.querySelector('input[name="selling_plan"]'); if (sp) { sp.value = ''; sp.disabled = true; }
      } else plans.hidden = false;
      box.querySelectorAll('[data-oe-appstle]').forEach(function (el) { el.hidden = single; });
    }
    if (form) form.addEventListener('submit', guardSingle, true);
    box.addEventListener('click', function (e) {
      var v = e.target.closest('[data-o-variant]');
      if (v) setTimeout(guardSingle, 0);
      setTimeout(function () {
        if (v && packId) show(String(v.dataset.variantId) === String(packId) ? 'pack' : (hero.dataset.first === 'media' ? 'm1' : hero.dataset.first));
        sync();
      }, 0);
    });
    setTimeout(function () { guardSingle(); sync(); }, 0);
  });
})();
